import { render, staticRenderFns } from "./B202.vue?vue&type=template&id=6a83d816&scoped=true"
import script from "./B202.vue?vue&type=script&lang=js"
export * from "./B202.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Cy.css?vue&type=style&index=0&id=6a83d816&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83d816",
  null
  
)

export default component.exports